/**
 * Zählt die Neuladeversuche, mit denen ein Nutzer eine abweichende Fassung zu beheben versucht.
 *
 * Nach dem zweiten erfolglosen Versuch verweist der Hinweis auf den Benutzerservice, denn es gibt
 * Ursachen, die ein Neuladen nicht heilt: eine zwischen mehreren Server-Kopien flackernde
 * Sollfassung oder eine dauerhaft falsch verdrahtete Backend-Adresse.
 *
 * Der Zähler liegt im sessionStorage, weil er das Neuladen überleben muss; gezählt wird beim Druck
 * auf den Knopf, damit nur abgeschlossene Versuche zählen.
 *
 * Ein Speicherfehler wird als 0 behandelt: Anders als bei ConfigService.getDeviationCount schützt
 * der Zähler hier vor keiner automatischen Schleife, er entscheidet nur über einen zusätzlichen
 * Satz im Hinweis.
 */
const RELOAD_COUNT_KEY = 'privacyPolicyVersionReloadCount';

export const RELOAD_ATTEMPTS_BEFORE_SUPPORT_HINT = 2;

export function readReloadCount(): number {
  try {
    const value = sessionStorage.getItem(RELOAD_COUNT_KEY);
    if (!value) {
      return 0;
    }
    const count = parseInt(value, 10);
    return isNaN(count) ? 0 : count;
  } catch (error) {
    return 0;
  }
}

export function countReloadAttempt(): void {
  try {
    sessionStorage.setItem(RELOAD_COUNT_KEY, `${readReloadCount() + 1}`);
  } catch (error) {
    // INFO: Ohne Zähler bleibt nur der Hinweis auf den Benutzerservice aus, die Bedienung nicht.
  }
}

export function clearReloadCount(): void {
  try {
    sessionStorage.removeItem(RELOAD_COUNT_KEY);
  } catch (error) {
    // INFO: siehe countReloadAttempt
  }
}
